export default __webpack_public_path__ + "static/Spirulina-b3631e3a6d9097a636be7e1c332e7a3f.jpg";